var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"login-page-layout"},[_c('div',{staticClass:"login-page-layout__wrapper px-4 px-lg-0"},[_vm._t("default"),_vm._t("before-wrapper")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }